import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { POST_TRANSAZIONI_ADD } from '../../../../actions/Buy'
import {
  GET_FINDOMESTIC_FIRMA_CONTRATTI,
  GET_INFOCERT_CERTIFICATO,
  GET_ORDINI_CODICE_PREVENTIVO,
  POST_BONIFICO_FILE_UPLOAD,
  POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI,
  POST_FINDOMESTIC_FILE_UPLOAD,
  POST_FINDOMESTIC_FIRMA_PIN,
  POST_INFOCERT_CERTIFICATO,
} from '../../../../constants/ActionTypes'

class ErrorModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onEscape = this.onEscape.bind(this)
  }

  onEscape({ keyCode }) {
    if (keyCode === 27 && this.props.error.closable) {
      this.props.onClose()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onEscape)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscape)
  }

  getTitle(which) {
    let title = ''

    switch (which) {
      case 'custom':
        title = this.props.error.title || 'Oops, qualcosa non va'
        break
      case `${POST_TRANSAZIONI_ADD}_HTTP_400_BCODE_87`:
      case 'auto_non_disponibile':
        title = 'Auto non disponibile'
        break
      case 'dati_non_corretti':
        title = 'Controlla i dati inseriti'
        break
      case 'errore_caricamento_file':
        title = 'Problema di caricamento'
        break
      case 'errore_connessione':
        title = 'Errore di connessione'
        break
      case 'sessione_scaduta':
        title = 'Sessione scaduta'
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_600`:
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_601`:
        title = 'Errore token Findomestic'
        break
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_604`:
        title = 'Salvataggio clausole certificato Infocert fallito'
        break
      case `${GET_FINDOMESTIC_FIRMA_CONTRATTI}_HTTP_500_BCODE_605`:
        title = 'Recupero contratti fallito'
        break
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_500_BCODE_607`:
        title = 'impossibile firmare i contratti'
        break
      case `${GET_ORDINI_CODICE_PREVENTIVO}_HTTP_400_BCODE_2`:
        title = 'Codice preventivo non valido'
        break
      case `${GET_ORDINI_CODICE_PREVENTIVO}_HTTP_404_BCODE_4`:
        title = 'Codice preventivo già utilizzato'
        break
      case `${POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI}_HTTP_400_BCODE_700`:
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_504_JSON_ERROR`:
      case 'generic':
      default:
        title = 'Oops, qualcosa non va'
        break
    }

    return title
  }

  hasLink(which) {
    let _hasLink = false

    switch (which) {
      case 'custom':
        _hasLink = this.props.error.linkText && this.props.error.linkHref
        break
      default:
        _hasLink = false
        break
    }

    return _hasLink
  }

  getLinkText(which) {
    let linkText = ''

    switch (which) {
      case 'custom':
        linkText = this.props.error.linkText
        break
      default:
        linkText = '#'
        break
    }

    return linkText
  }

  getLinkHref(which) {
    let linkHref = ''

    switch (which) {
      case 'custom':
        linkHref = this.props.error.linkHref
        break
      default:
        linkHref = '#'
        break
    }

    return linkHref
  }

  getMessage(which) {
    let message = ''

    switch (which) {
      case 'custom':
        message =
          this.props.error.message ||
          'Abbiamo riscontrato un problema che stiamo cercando di risolvere. Per favore, prova di nuovo.'
        break
      case `${POST_TRANSAZIONI_ADD}_HTTP_400_BCODE_87`:
      case 'auto_non_disponibile':
        message =
          this.props.product.linea_prodotto === 'NLT_ARVAL'
            ? 'Auto momentaneamente esaurita - Contatta il nostro Servizio Clienti per maggiori info!'
            : 'Oops, qualcuno ha già acquistato questa automobile.'
        break
      case 'dati_non_corretti':
        message =
          'Ehi, qualcosa non torna nella compilazione del form. Controlla che i dati siano corretti.'
        break
      case 'errore_caricamento_file':
        message =
          'Stai cercando di caricare un file che non possiamo accettare. (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)'
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_504_JSON_ERROR`:
      case 'errore_connessione':
        message =
          'Stiamo riscontrando problemi di connessione. Per favore, riprova tra qualche minuto.'
        break
      case 'sessione_scaduta':
        message =
          'La sessione relativa al tuo ordine è scaduta poichè sono trascorsi più di 14 giorni dalla ricezione della mail con il link di recupero.'
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_600`:
        message =
          "Il servizio di Findomestic ha riscontrato un errore, riprova piu' tardi"
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_601`:
        message =
          'Il servizio di Findomestic ha riscontrato un errore: invalid response from Findomestic webservice - token'
        break
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_604`:
        message =
          'Il servizio di Findomestic ha riscontrato un errore: invalid response from Findomestic webservice - salvataggio certificato infocert'
        break
      case `${GET_FINDOMESTIC_FIRMA_CONTRATTI}_HTTP_500_BCODE_605`:
        message =
          'Invalid response from Findomestic webservice - recupero contratti'
        break
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_500_BCODE_607`:
        message =
          'invalid response from Findomestic webservice - salvataggio contratti'
        break
      case `${GET_ORDINI_CODICE_PREVENTIVO}_HTTP_400_BCODE_2`:
        message = 'Il codice preventivo inserito risulta errato'
        break
      case `${GET_ORDINI_CODICE_PREVENTIVO}_HTTP_404_BCODE_4`:
        message =
          'Il codice preventivo inserito risulta già utilizzato in precedenza'
        break
      case `${POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI}_HTTP_400_BCODE_700`:
        message =
          this.props.error.body_json && this.props.error.body_json.result
            ? this.props.error.body_json.result
            : 'Questa combinazione di prodotti non è consentita'
        break
      case `${POST_BONIFICO_FILE_UPLOAD}_HTTP_415_BCODE_0`:
      case `${POST_FINDOMESTIC_FILE_UPLOAD}_HTTP_415_BCODE_0`:
        message =
          this.props.error.body_json && this.props.error.body_json.result
            ? Object.values(this.props.error.body_json.result)[0].msg
            : 'Errore - Abbiamo riscontrato un problema che stiamo cercando di risolvere. Per favore, prova di nuovo.'
        break
      case 'generic':
      default:
        const responseResult =
          this.props.error.body_json && this.props.error.body_json.result
        const responseMessage =
          this.props.error.body_json && this.props.error.body_json.message
            ? this.props.error.body_json.message
            : 'Errore generico'

        let responseResultText =
          'Abbiamo riscontrato un problema che stiamo cercando di risolvere. Per favore, prova di nuovo.'

        if (
          responseResult &&
          typeof responseResult === 'object' &&
          responseResult.info
        ) {
          // ordini quando va in errore mette il dettaglio dell'errore dentro result.info
          responseResultText = responseResult.info
        } else if (responseResult && typeof responseResult === 'string') {
          responseResultText = responseResult
        } else if (
          responseResult &&
          typeof responseResult === 'object' &&
          responseResult.ex_message
        ) {
          responseResultText = responseResult.ex_message.message
          if (responseResult.ex_message.code) {
            responseResultText += ` (code ${responseResult.ex_message.code})`
          }
        }

        message = `${responseMessage} - ${responseResultText}`

        break
    }

    return message
  }

  getLogo(which) {
    let logo = ''

    const logos = {
      auto_non_disponibile: this.autoNonDisponibileLogo(),
      dati_non_corretti: this.datiNonCorrettiLogo(),
      errore_caricamento_file: this.erroreCaricamentoFileLogo(),
      errore_connessone: this.erroreConnessioneLogo(),
      sessone_scaduta: this.sessioneScadutaLogo(),
      generic_logo: this.genericLogo(),
    }

    switch (which) {
      case 'custom':
        logo = logos[this.props.error.logo]
        break
      case `${POST_TRANSAZIONI_ADD}_HTTP_400_BCODE_87`:
      case 'auto_non_disponibile':
        logo = this.autoNonDisponibileLogo()
        break
      case 'dati_non_corretti':
        logo = this.datiNonCorrettiLogo()
        break
      case 'errore_caricamento_file':
        logo = this.erroreCaricamentoFileLogo()
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_504_JSON_ERROR`:
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_504_JSON_ERROR`:
      case 'errore_connessione':
        logo = this.erroreConnessioneLogo()
        break
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_600`:
      case `${GET_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_601`:
      case `${POST_INFOCERT_CERTIFICATO}_HTTP_500_BCODE_604`:
      case `${GET_FINDOMESTIC_FIRMA_CONTRATTI}_HTTP_500_BCODE_605`:
      case `${POST_FINDOMESTIC_FIRMA_PIN}_HTTP_500_BCODE_607`:
      case 'sessione_scaduta':
        logo = this.sessioneScadutaLogo()
        break
      case 'generic':
      case `${POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI}_HTTP_400_BCODE_700`:
      default:
        logo = this.genericLogo()
        break
    }

    return logo
  }

  genericLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <circle className="svg--red" cx="50.2" cy="45.5" r="40.8" />
        <g>
          <path
            className="svg--white"
            d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                    c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                    c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z"
          />
          <g>
            <path
              className="svg--gray"
              d="M30.9,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                      C36.5,67.1,33.6,65.1,30.9,65.1z M30.9,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                      c0.1,0.1,0.3,0.3,0.3,0.9C32.1,71.7,31.4,71.9,30.9,71.9z"
            />
            <path
              className="svg--gray"
              d="M69.7,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                      C75.2,67.1,72.4,65.1,69.7,65.1z M69.7,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                      c0.1,0.1,0.3,0.3,0.3,0.9C70.9,71.7,70.1,71.9,69.7,71.9z"
            />
            <path
              className="svg--gray"
              d="M69.8,58.4c0.4-0.5,0.6-1.2,0.4-1.8l-2.9-13.7c-0.2-1-1.1-1.7-2.1-1.7H35.4c-1,0-1.9,0.7-2.1,1.7l-3.1,13.7
                      c-0.1,0.6,0,1.3,0.4,1.8c0.4,0.5,1,0.8,1.7,0.8h35.7C68.7,59.2,69.4,58.9,69.8,58.4z M35.1,54.8l2.1-9.3h26.3l2,9.3H35.1z"
            />
            <path
              className="svg--gray"
              d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                      c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                      c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z M34.4,88.8
                      c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z M70.9,88.8c0,1.4-1.2,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z
                       M79.9,79.8c0,1.3-1,2.3-2.3,2.3H22.9c-1.3,0-2.3-1-2.3-2.3l0.2-18.3c0-1.3,1-2.3,2.3-2.3h2.3c1,0,1.9-0.7,2.1-1.7l4.1-18.9h37.5
                      l4.1,18.9c0.2,1,1.1,1.7,2.1,1.7h2.3c1.3,0,2.3,1,2.3,2.3V79.8z"
            />
          </g>
          <g>
            <path
              className="svg--gray"
              d="M54.9,75c-1,0-1.7-0.8-1.7-1.7c0-2.2-1.8-2.9-2.9-2.9c-1.2,0-3,0.8-3,2.9c0,1-0.8,1.7-1.7,1.7
                      c-1,0-1.7-0.8-1.7-1.7c0-4,3.3-6.4,6.4-6.4c3.2,0,6.4,2.4,6.4,6.4C56.6,74.2,55.9,75,54.9,75z"
            />
          </g>
        </g>
      </svg>
    )
  }

  autoNonDisponibileLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <circle className="svg--red" cx="50.2" cy="45.5" r="40.8" />
        <g>
          <path
            className="svg--white"
            d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                      c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                      c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z"
          />
          <g>
            <path
              className="svg--gray"
              d="M30.9,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                        C36.5,67.1,33.6,65.1,30.9,65.1z M30.9,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                        c0.1,0.1,0.3,0.3,0.3,0.9C32.1,71.7,31.4,71.9,30.9,71.9z"
            />
            <path
              className="svg--gray"
              d="M69.7,65.1c-2.7,0-5.5,1.9-5.5,5.5c0,1.7,0.6,3.1,1.8,4.2c1,0.9,2.3,1.4,3.8,1.4c2.7,0,5.5-1.9,5.5-5.5
                        C75.2,67.1,72.4,65.1,69.7,65.1z M69.7,71.9c-0.5,0-1.2-0.2-1.2-1.2c0-1.1,0.8-1.2,1.2-1.2c0.3,0,0.7,0.1,0.9,0.3
                        c0.1,0.1,0.3,0.3,0.3,0.9C70.9,71.7,70.1,71.9,69.7,71.9z"
            />
            <path
              className="svg--gray"
              d="M69.8,58.4c0.4-0.5,0.6-1.2,0.4-1.8l-2.9-13.7c-0.2-1-1.1-1.7-2.1-1.7H35.4c-1,0-1.9,0.7-2.1,1.7l-3.1,13.7
                        c-0.1,0.6,0,1.3,0.4,1.8c0.4,0.5,1,0.8,1.7,0.8h35.7C68.7,59.2,69.4,58.9,69.8,58.4z M35.1,54.8l2.1-9.3h26.3l2,9.3H35.1z"
            />
            <path
              className="svg--gray"
              d="M77.6,54.8h-0.5L72.9,36c-0.2-1-1.1-1.7-2.1-1.7h-41c-1,0-1.9,0.7-2.1,1.7l-4.1,18.9h-0.5
                        c-3.7,0-6.7,3-6.7,6.6l-0.2,18.3c0,0,0,0,0,0c0,3.7,3,6.7,6.7,6.7h2.5v2.3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7v-2.3h23.2v2.3
                        c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-2.3h2.3c3.7,0,6.7-3,6.7-6.7V61.5C84.2,57.8,81.2,54.8,77.6,54.8z M34.4,88.8
                        c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z M70.9,88.8c0,1.4-1.2,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-2.3h4.7V88.8z
                         M79.9,79.8c0,1.3-1,2.3-2.3,2.3H22.9c-1.3,0-2.3-1-2.3-2.3l0.2-18.3c0-1.3,1-2.3,2.3-2.3h2.3c1,0,1.9-0.7,2.1-1.7l4.1-18.9h37.5
                        l4.1,18.9c0.2,1,1.1,1.7,2.1,1.7h2.3c1.3,0,2.3,1,2.3,2.3V79.8z"
            />
          </g>
          <g>
            <path
              className="svg--gray"
              d="M54.9,75c-1,0-1.7-0.8-1.7-1.7c0-2.2-1.8-2.9-2.9-2.9c-1.2,0-3,0.8-3,2.9c0,1-0.8,1.7-1.7,1.7
                        c-1,0-1.7-0.8-1.7-1.7c0-4,3.3-6.4,6.4-6.4c3.2,0,6.4,2.4,6.4,6.4C56.6,74.2,55.9,75,54.9,75z"
            />
          </g>
        </g>
      </svg>
    )
  }

  datiNonCorrettiLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <circle className="svg--red" cx="50.2" cy="45.5" r="40.8" />
        <path
          className="svg--white"
          d="M69.2,34.6L69.2,34.6l-44.9,0v60.9h44.9v-0.1c3.3-0.2,6-3,6-6.4l0.1-48C75.3,37.6,72.6,34.8,69.2,34.6z"
        />
        <g>
          <path
            className="svg--gray"
            d="M71.3,89c0,1.3-0.9,2.3-2.1,2.5v-53c1.3,0.2,2.2,1.2,2.2,2.5L71.3,89z M28.2,38.5h37.2v53.2H28.2V38.5z
                       M69.2,34.6L69.2,34.6l-44.9,0v60.9h44.9v-0.1c3.3-0.2,6-3,6-6.4l0.1-48C75.3,37.6,72.6,34.8,69.2,34.6z"
          />
          <rect
            className="svg--gray"
            height="3.8"
            width="12.3"
            x="40.5"
            y="77.7"
          />
          <rect
            className="svg--gray"
            height="3.8"
            width="12.3"
            x="40.5"
            y="83.5"
          />
          <path
            className="svg--gray"
            d="M37.7,65.8c1.1-3.8,4.7-6.5,8.8-6.5h0c0,0,0,0,0,0c4.1,0,7.6,2.7,8.8,6.5H37.7z M44.4,55.2
                      C44.3,55.1,44.2,55,44,55c-0.6-0.4-1.1-0.8-1.4-1.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4-0.7-0.6-1.5-0.6-2.3c0-2.6,2.1-4.7,4.7-4.7
                      c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7h0h0C45.8,55.7,45,55.5,44.4,55.2z M52.2,57c1.6-1.5,2.7-3.7,2.7-6.1
                      c0-4.6-3.8-8.4-8.4-8.4c-4.6,0-8.4,3.8-8.4,8.4c0,1.4,0.4,2.9,1.1,4.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.5,0.8,1,1.2,1.4
                      c-3.9,2-6.7,5.9-7,10.5c0,0.5,0.1,1,0.5,1.4c0.3,0.4,0.8,0.6,1.3,0.6h21.9c0.5,0,1-0.2,1.3-0.6c0.3-0.4,0.5-0.9,0.5-1.4
                      C58.9,62.9,56.1,59,52.2,57z"
          />
        </g>
      </svg>
    )
  }

  erroreCaricamentoFileLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <circle className="svg--red" cx="50.7" cy="45.5" r="40.8" />
        <g>
          <path
            className="svg--white"
            d="M72.8,50.6L56.7,34.4v0l0,0H35.6h-0.9v0.1c-3.3,0.2-6,3-6,6.4l-0.1,48c0,3.4,2.7,6.2,6.1,6.4v0h0.9h30.2h0.9
                      v-0.1c3.3-0.2,6-3,6-6.4L72.8,50.6L72.8,50.6z"
          />
          <path
            className="svg--gray"
            d="M72.8,50.6L56.7,34.4v0l0,0H35.6h-0.9v0.1c-3.3,0.2-6,3-6,6.4l-0.1,48c0,3.4,2.7,6.2,6.1,6.4v0h0.9h30.2h0.9
                      v-0.1c3.3-0.2,6-3,6-6.4L72.8,50.6L72.8,50.6z M68.9,50.8l-0.1,38.1c0,1.3-0.9,2.3-2.1,2.5l-32.1,0.1c-1.3-0.2-2.2-1.2-2.2-2.5
                      l0.1-48c0-1.3,0.9-2.3,2.1-2.5l22-0.1v6.5c0,3.2,2.6,5.8,5.8,5.8h6.3L68.9,50.8z"
          />
          <g>
            <path
              className="svg--gray"
              d="M56.4,58.9H45c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h11.4c0.6,0,1.1,0.5,1.1,1.1S57,58.9,56.4,58.9z"
            />
            <path
              className="svg--gray"
              d="M56.7,66.4l-5.2-5.2c-0.1-0.1-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0
                        c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0l0,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1
                        s-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0l-5.2,5.2c-0.5,0.5-0.5,1.2,0,1.6c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3
                        l3.2-3.2v8.3c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-8.3l3.2,3.2c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3
                        C57.1,67.6,57.1,66.9,56.7,66.4z"
            />
          </g>
        </g>
      </svg>
    )
  }

  erroreConnessioneLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <circle className="svg--red" cx="50.6" cy="45.5" r="40.8" />
        <g>
          <path
            className="svg--white"
            d="M48.9,43.8c-5.3,0.9-9.4,5.4-9.4,10.9v3.9c0,1,0.8,1.8,1.8,1.8H60c1,0,1.8-0.8,1.8-1.8v-3.8
                      c0-5.5-4-10.2-9.4-10.9v-7.4c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8L48.9,43.8L48.9,43.8z"
          />
          <path
            className="svg--white"
            d="M47.7,65.7c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v4.1h-2.9c-1,0-1.8,0.8-1.8,1.8v3.8
                      c0,5.5,4,10.2,9.4,10.9v7.4c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-7.4c5.3-0.9,9.4-5.4,9.4-10.9v-3.9c0-1-0.8-1.8-1.8-1.8H57v-4.1
                      c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v4.1h-5.8V65.7z"
          />
        </g>
        <g>
          <path
            className="svg--gray"
            d="M58.2,55v2.1H42.9V55c0.1-4.3,3.5-7.7,7.7-7.7C54.8,47.2,58.2,50.7,58.2,55z M48.8,43.8
                      c-5.3,0.9-9.4,5.4-9.4,10.9v3.9c0,1,0.8,1.8,1.8,1.8H60c1,0,1.8-0.8,1.8-1.8v-3.8c0-5.5-4-10.2-9.4-10.9v-7.4c0-1-0.8-1.8-1.8-1.8
                      c-1,0-1.8,0.8-1.8,1.8L48.8,43.8L48.8,43.8z"
          />
          <path
            className="svg--gray"
            d="M58.2,73.1v2.1c0,4.2-3.4,7.6-7.6,7.6S43,79.4,43,75.3v-2.1C43,73.2,58.2,73.2,58.2,73.1z M47.6,65.7
                      c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v4.1h-2.9c-1,0-1.8,0.8-1.8,1.8v3.8c0,5.5,4,10.2,9.4,10.9v7.4c0,1,0.8,1.8,1.8,1.8
                      s1.8-0.8,1.8-1.8v-7.4c5.3-0.9,9.4-5.4,9.4-10.9v-3.9c0-1-0.8-1.8-1.8-1.8H57v-4.1c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v4.1
                      h-5.8V65.7z"
          />
        </g>
      </svg>
    )
  }

  sessioneScadutaLogo() {
    return (
      <svg
        id="Livello_1"
        version="1.1"
        viewBox="0 0 100 100"
        x="0px"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        y="0px"
      >
        <g>
          <circle className="svg--red" cx="49.3" cy="46.1" r="40.8" />
          <g>
            <g>
              <path
                className="svg--white"
                d="M81.2,62.9h-2.9c-1-16.5-14.7-29.5-31.5-29.5c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5
                          c16.7,0,30.4-13.1,31.5-29.5h2.9c1.1,0,2-0.9,2-2C83.2,63.8,82.3,62.9,81.2,62.9z"
              />
            </g>
            <g>
              <path
                className="svg--gray"
                d="M54.3,62.8h-5.4v-9.9c0-1.1-0.9-2.1-2.1-2.1c-1.1,0-2.1,0.9-2.1,2.1v12c0,1.1,0.9,2.1,2.1,2.1h7.5
                          c1.1,0,2.1-0.9,2.1-2.1C56.3,63.8,55.4,62.8,54.3,62.8z"
              />
              <path
                className="svg--gray"
                d="M81.2,62.9h-2.9c-1-16.5-14.7-29.5-31.5-29.5c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5
                          c16.7,0,30.4-13.1,31.5-29.5h2.9c1.1,0,2-0.9,2-2C83.2,63.8,82.3,62.9,81.2,62.9z M46.9,92.4c-12.6,0-23.2-8.5-26.5-20.1h2.9
                          c1.1,0,2-0.9,2-2s-0.9-2-2-2h-3.7c-0.1-1.1-0.2-2.3-0.2-3.5c0-1.1,0.1-2.1,0.2-3.1h8.6c1.1,0,2-0.9,2-2s-0.9-2-2-2h-7.9
                          c3.2-11.7,13.9-20.4,26.6-20.4c15.2,0,27.5,12.3,27.5,27.5S62.1,92.4,46.9,92.4z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }

  render() {
    if (this.props.error.suppressOnlyErrorNotice) {
      return null
    }

    return (
      <div
        className={`the-modal modal${this.props.show ? ' show' : ''}`}
        data-modal={this.props.errorType}
      >
        <div className="error__popup">
          {this.props.error.closable === false ? null : (
            <div className="error__popup__close" onClick={this.props.onClose}>
              <i className="icon-close"></i>
            </div>
          )}
          <div className="error__popup__content">
            <div className="error__popup__svg">
              {this.getLogo(this.props.errorType)}
            </div>

            <h4 className="error__popup__title">
              {this.getTitle(this.props.errorType)}
            </h4>

            <p className="error__popup__text">
              {this.getMessage(this.props.errorType)}
            </p>
            <div
              style={{
                fontSize: '10px',
                wordWrap: 'break-word',
                color: '#bbb',
              }}
            >
              {this.props.errorType && this.props.errorType !== 'custom' ? (
                <div>
                  {this.props.errorType}
                  <br />
                </div>
              ) : null}

              {this.props.error && this.props.error.brum_session_id ? (
                <div>
                  bsi {this.props.error.brum_session_id}
                  <br />
                </div>
              ) : null}

              {this.props.error && this.props.error.xray ? (
                <div>
                  xray {this.props.error.xray}
                  <br />
                </div>
              ) : null}

              {this.props.error && this.props.error.selloutCallHash ? (
                <div>
                  sch {this.props.error.selloutCallHash}
                  <br />
                </div>
              ) : null}
            </div>

            {this.props.errorType === 'auto_non_disponibile' ? (
              <div className="brumbrum-link">
                <a className="error__popup__link" href="/auto">
                  Scopri altre auto
                </a>
              </div>
            ) : null}

            {this.hasLink(this.props.errorType) ? (
              <a
                className="error__popup__link"
                href={this.getLinkHref(this.props.errorType)}
              >
                {this.getLinkText(this.props.errorType)}
              </a>
            ) : null}

            {this.props.errorType === 'dati_non_corretti' ? (
              <a
                className="error__popup__link"
                href="/contatti"
                target="_blank"
              >
                Hai bisogno di aiuto?
              </a>
            ) : null}

            {this.props.errorType === 'sessione_scaduta' ? (
              <a
                className="error__popup__link"
                href={window.brumbrum.id_auto}
                rel="noreferrer"
                target="_blank"
              >
                Clicca qui per ricominciare l'ordine
              </a>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}

ErrorModal.defaultProps = {
  error: {
    closable: true,
  },
}

ErrorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  errorType: PropTypes.string.isRequired,
  uuid: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  error: PropTypes.object,
}

export default ErrorModal
